/**
 * Workshops that trade under their OWN brand (white-label).
 *
 * The server decides which brand applies (by workshop id — `src/utils/workshopBrand.ts`
 * in the backend) and sends its key: on the signed-in user, and on the customer pages it
 * serves. This file only says what each brand looks like. Its colours live in
 * `brands.css`; the values here are for the few pages that paint with inline styles.
 *
 * Mize Pro is "no brand": every lookup returns null and the page stays as it is.
 */
export type BrandKey = 'pitstop';

export interface Brand {
  key: BrandKey;
  name: { ar: string; en: string };
  /** Wordmark for light surfaces. */
  logo: string;
  /** Wordmark for dark surfaces. */
  logoOnDark: string;
  /** Square mark: favicon and the phone top bar. */
  mark: string;
  favicon: string;
  appleTouchIcon: string;
  /** Extra webfont stylesheet, loaded only while the brand is showing. */
  fontsHref?: string;
  /** For pages styled inline (the customer payment page). */
  colors: {
    accent: string;      // fills: buttons, highlights
    onAccent: string;    // text on an accent fill
    accentInk: string;   // the accent as text on white
    accentSoft: string;  // pale tint
  };
}

export const BRANDS: Record<BrandKey, Brand> = {
  // pitstop.sa: white pages, charcoal #404040, orange #E8731E buttons with white text.
  pitstop: {
    key: 'pitstop',
    name: { ar: 'بيت ستوب', en: 'Pit Stop' },
    logo: '/brands/pitstop/logo.png',
    logoOnDark: '/brands/pitstop/logo-on-dark.png',
    mark: '/brands/pitstop/mark-192.png',
    favicon: '/brands/pitstop/mark-32.png',
    appleTouchIcon: '/brands/pitstop/apple-touch-icon.png',
    fontsHref: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap',
    colors: { accent: '#E8731E', onAccent: '#FFFFFF', accentInk: '#B4520B', accentSoft: '#FDEBDD' },
  },
};

export function brandFor(key?: string | null): Brand | null {
  return key && Object.prototype.hasOwnProperty.call(BRANDS, key) ? BRANDS[key as BrandKey] : null;
}
